import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Row, Col } from 'antd';
import FormModal from './GroupFormModal'
@inject('indexManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  componentDidMount() {
  }
  handleCreate = () => {
    const { indexManagementStore } = this.props;
    indexManagementStore.onGetIndexNameAction()
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  render() {
    return (
      <>
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button style={{ marginRight: 10 }} onClick={this.handleCreate} type='primary'>Add</Button>
          </Col>
        </Row>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    );
  }
}

export default SearchForm;
